import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { GenerationPage } from './GenerationPage';
import { readGenerationPrefill } from './generationPrefill';

/**
 * `/generation`, remounted for a fresh hand-off.
 *
 * `GenerationPage` reads a prefill from router state once, on its first render,
 * then spends the state. That is right for a hand-off from another screen, but
 * the assistant can hand one over while the brief is already open, and a
 * same-route navigation would not remount the form. So the form is keyed on
 * the navigation that last carried a prefill: a new one remounts it (the
 * prefill outranks the stored draft, as on any arrival), and the page's own
 * replace that clears the state changes nothing.
 */
export function GenerationRoute() {
  const location = useLocation();
  const [formKey, setFormKey] = useState(location.key);

  if (location.key !== formKey && readGenerationPrefill(location.state) !== null) {
    setFormKey(location.key);
  }

  return <GenerationPage key={formKey} />;
}
